<template>
  <div>
    <div v-if="!isLoading" class="container">
      <StudioMediaDetails :media="media" />
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import StudioMediaDetails from '@/web/components/products/StudioMediaDetails';
import RefreshData from '@/web/mixins/refreshData';
import { getStudioURL } from '@/web/router/custom-domain-utils';
import { mapGetters } from 'vuex';
import LegalWaiverModal from '@/web/components/shop/LegalWaiverModal';

export default Vue.extend({
  name: 'StudioMedia',
  mixins: [RefreshData],
  components: {
    StudioMediaDetails,
  },
  computed: {
    ...mapGetters({
      product: 'product/product',
    }),
    isLoading() {
      return !this.media;
    },
  },
  data() {
    return {
      media: null,
    };
  },
  methods: {
    async loadData() {
      const waiver = await this.$store.dispatch('studio/getWaiverToBeSigned', {
        studioURL: getStudioURL(this.$route),
      });
      if (waiver.id) {
        this.$modal.show(
          LegalWaiverModal,
          { showCloseButton: false, waiver },
          { clickToClose: false, classes: 'vm--inline-modal' }
        );
      }
      // do not change != to !== because it may not work
      if (!this.product || this.product.id != this.$route.params.product_id) {
        const studioURL = getStudioURL(this.$route);
        const productId = this.$route.params.product_id;
        this.$store.dispatch('product/getProductDetail', {
          studioURL,
          productId,
        });
      }
      try {
        this.media = await this.$store.dispatch('studio/getProductMedia', {
          studioURL: getStudioURL(this.$route),
          productId: this.$route.params.product_id,
          mediaId: this.$route.params.media_id,
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: this.$t('STUDIO.NOTIFICATIONS.LOAD_MEDIA_ERROR'),
          text: `Error: ${error}`,
          duration: -1, // stay ON
        });
      }
    },
  },
  mounted() {
    this.loadData();
  },
  beforeDestroy() {
    this.$modal.hideAll();
  },
});
</script>

<style lang="scss" scoped></style>
